import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiHelper from '../../utils/apiHelpers';
import ReCAPTCHA from 'react-google-recaptcha';
import Input from '../common/Input';
import Button from '../common/Button';
import Alert from '../common/Alert';
const config = require('../../config/config');

const Login = () => {
  const [state, setState] = useState({
    username: '',
    password: '',
    errorMessage: null,
  });

  const navigate = useNavigate(); // Use navigate hook for redirection
  const recaptchaRef = useRef();

  const handleChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      // Execute invisible reCAPTCHA
      const captchaToken = await recaptchaRef.current.executeAsync();
      
      await apiHelper.login({
        username: state.username,
        password: state.password,
        key: captchaToken,
      });
      navigate('/findcard');
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
          errorMessage = 'Email o contraseña invalidas';
        } else if (statusCode === 403) {
          errorMessage = 'Captcha invalido';
        } else {
          errorMessage = error.message;
        }
      } else {
        errorMessage = 'Error de conexión con el servidor';
      }

      setState(prevState => ({
        ...prevState,
        ['errorMessage']: errorMessage,
      }));

      // Reset reCAPTCHA after failed attempt
      recaptchaRef.current.reset();
    }
  };

  return (
    <div className="flex flex-col w-full h-full items-center justify-center">
      <img
        src={process.env.PUBLIC_URL + '/img/isologo.png'}
        width="170px"
        alt="ManaValue"
      />
      <div className="flex flex-col items-center gap-y-4 min-w-[300px]">
        <h1 className="text-2xl text-center">Iniciar sesión</h1>
        <Input
          type="text"
          name="username"
          placeholder="Usuario"
          value={state.username}
          onChange={handleChange}
          required={true}
          autoFocus
        />
        <Input
          type="password"
          name="password"
          placeholder="Contraseña"
          value={state.password}
          onChange={handleChange}
          required={true}
        />
        <ReCAPTCHA 
          ref={recaptchaRef}
          sitekey={config.captcha} 
          size="invisible"
        />
        <Alert>{state.errorMessage}</Alert>
        <Button
          className="w-full"
          onClick={handleSubmit}
          iconClass="fas fa-sign-in-alt">
          Iniciar sesión
        </Button>
        <Link
          className="text-accentDark hover:text-accentLight hover:underline block text-center"
          to="/recover_password">
          Olvide mi Contraseña
        </Link>
      </div>
    </div>
  );
};

export default Login;
